import bg_BG from '@/config/i18n/bg-BG.json'
import en_GB from '@/config/i18n/en-GB.json'
import zh_CS from '@/config/i18n/zh-CN.json'
import zh_TW from '@/config/i18n/zh-TW.json'
import cs_CZ from '@/config/i18n/cs-CZ.json'
import da_DK from '@/config/i18n/da-DK.json'
import de_DE from '@/config/i18n/de-DE.json'
import el_GR from '@/config/i18n/el-GR.json'
import es_ES from '@/config/i18n/es-ES.json'
import et_EE from '@/config/i18n/et-EE.json'
import fi_FI from '@/config/i18n/fi-FI.json'
import fr_FR from '@/config/i18n/fr-FR.json'
import hr_HR from '@/config/i18n/hr-HR.json'
import hu_HU from '@/config/i18n/hu-HU.json'
import it_IT from '@/config/i18n/it-IT.json'
import ja_JP from '@/config/i18n/ja-JP.json'
import ko_KR from '@/config/i18n/ko-KR.json'
import lt_LT from '@/config/i18n/lt-LT.json'
import lv_LV from '@/config/i18n/lv-LV.json'
import nl_NL from '@/config/i18n/nl-NL.json'
import no_NO from '@/config/i18n/no-NO.json'
import pl_PL from '@/config/i18n/pl-PL.json'
import pt_PT from '@/config/i18n/pt-PT.json'
import ro_RO from '@/config/i18n/ro-RO.json'
import ru_RU from '@/config/i18n/ru-RU.json'
import sk_SK from '@/config/i18n/sk-SK.json'
import sl_SI from '@/config/i18n/sl-SI.json'
import sv_SE from '@/config/i18n/sv-SE.json'
import th_TH from '@/config/i18n/th-TH.json'
import tr_TR from '@/config/i18n/tr-TR.json'
import zh_HK from '@/config/i18n/zh-HK.json'
import zh_MO from '@/config/i18n/zh-MO.json'

import VueI18n from 'vue-i18n'

export default new VueI18n({
  fallbackLocale: 'en-GB',
  messages: {
    'bg-BG': bg_BG,
    'en-GB': en_GB,
    'en-US': en_GB,
    'zh-CN': zh_CS,
    'zh-TW': zh_TW,
    'cs-CZ': cs_CZ,
    'da-DK': da_DK,
    'de-DE': de_DE,
    'el-GR': el_GR,
    'es-ES': es_ES,
    'et-EE': et_EE,
    'fi-FI': fi_FI,
    'fr-FR': fr_FR,
    'hr-HR': hr_HR,
    'hu-HU': hu_HU,
    'it-IT': it_IT,
    'ja-JP': ja_JP,
    'ko-KR': ko_KR,
    'lt-LT': lt_LT,
    'lv-LV': lv_LV,
    'nl-NL': nl_NL,
    'no-NO': no_NO,
    'pl-PL': pl_PL,
    'pt-PT': pt_PT,
    'ro-RO': ro_RO,
    'ru-RU': ru_RU,
    'sk-SK': sk_SK,
    'sl-SI': sl_SI,
    'sv-SE': sv_SE,
    'th-TH': th_TH,
    'tr-TR': tr_TR,
    'zh-HK': zh_HK,
    'zh-MO': zh_MO,
    'en-TH': en_GB,
    'de-CH': de_DE,
    'fr-CH': fr_FR,
    'it-CH': it_IT,
    'en-ZA': en_GB,
    'en-MT': en_GB,
    'en-IN': en_GB,
    'en-XD': en_GB,
    'en-CY': en_GB,
    'nl-BE': nl_NL,
    'fr-BE': fr_FR,
    'de-AT': de_DE,
    'en-XA': en_GB,
    'de-LU': de_DE,
    'fr-LU': fr_FR,
    'de-LI': de_DE,
  },
})
